var _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSustainabilityShape3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 347.22 347.22"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "SustainabilityShape3_svg__SustainabilityShape3Mask",
    clipPathUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 0.5,
    r: 0.5
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzNDcuMjIgMzQ3LjIyIj4KCTxkZWZzPgoJCTxjbGlwUGF0aCBpZD0iU3VzdGFpbmFiaWxpdHlTaGFwZTNNYXNrIiBjbGlwUGF0aFVuaXRzPSJvYmplY3RCb3VuZGluZ0JveCI+CgkJCTxjaXJjbGUgY3g9Ii41IiBjeT0iLjUiIHI9Ii41IiAvPgoJCTwvY2xpcFBhdGg+Cgk8L2RlZnM+Cjwvc3ZnPgo=";
export { SvgSustainabilityShape3 as ReactComponent };